const ActionNames = require('../VerifoneActionNames');

/**
 * See "POS Client Integration Guide v2.1 - 15th April 2015.pdf" page 57.
 *
 * @type {{string: {id: number, message: string, customerFacingMessage?:string, icon?:string, actions?:string[]}}}}
 */
const Statuses = {
    PROCESSING_TRANSACTION: {
        id: 0,
        message: 'Processing Transaction',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    WAITING_FOR_GRATUITY: {
        id: 1,
        message: 'Waiting For Gratuity',
        customerFacingMessage: 'Enter Gratuity',
        icon: 'pause',
    },
    GRATUITY_BEING_ENTERED: {
        id: 2,
        message: 'Gratuity Being Entered',
        icon: 'pause',
    },
    AWAITING_CARD: {
        id: 3,
        message: 'Awaiting Card',
        customerFacingMessage: 'Insert / Present Card',
        icon: 'pause',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    SWIPE_CARD: {
        id: 4,
        message: 'Swipe Card',
        customerFacingMessage: 'Swipe Card',
        icon: 'pause',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    CARD_INSERTED: {
        id: 5,
        message: 'Card Inserted',
        customerFacingMessage: 'Please Wait',
    },
    CARD_REMOVED: {
        id: 6,
        message: 'Card Removed',
        customerFacingMessage: 'Please Wait',
    },
    CARD_PROCESSING: {
        id: 7,
        message: 'Card Processing',
        customerFacingMessage: 'Do Not Remove Card',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    CHANGE_CARD: {
        id: 8,
        message: 'Change Card',
        customerFacingMessage: 'Use Alternative Payment Method',
        icon: 'pause',
        actions: [
            // ActionNames.CANCEL_TRANSACTION, // Docs say you can cancel now but it doesn't work.
        ],
    },
    CONTACT_TRANSACTION_REQUIRED: {
        id: 9,
        message: 'Contact Transaction Required',
    },
    KEY_IN_CARD_DETAILS: {
        id: 10,
        message: 'Key In Card Details',
        customerFacingMessage: 'Key Card Number',
        icon: 'hand-up',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    WAITING_FOR_CASHBACK: {
        id: 11,
        message: 'Waiting For Cashback',
        customerFacingMessage: 'Enter Cashback',
        icon: 'question-sign',
        actions: [
            ActionNames.CASHBACK_REQUIRED,
            ActionNames.CASHBACK_NOT_REQUIRED,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    PIN_ENTRY: {
        id: 12,
        message: 'Pin Entry',
        customerFacingMessage: 'Enter PIN',
        icon: 'pause',
    },
    RISK_MANAGEMENT_COMPLETE: {
        id: 13,
        message: 'Risk Management Complete',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    AUTHORISING_TRANSACTION: {
        id: 14,
        message: 'Authorising Transaction',
        customerFacingMessage: 'Please Wait',
    },
    WAITING_FOR_RESULT: {
        id: 15,
        message: 'Waiting For Result',
        customerFacingMessage: 'Please Wait',
    },
    AUTH_RESULT_RECEIVED: {
        id: 16,
        message: 'Auth Result Received',
        customerFacingMessage: 'Please Wait',
    },
    PRINTING_MERCHANT_RECEIPT: {
        id: 17,
        message: 'Printing Merchant Receipt',
        customerFacingMessage: 'Please Wait',
        icon: 'print',
    },
    SIGNATURE_CONFIRMATION_REQUIRED: {
        id: 18,
        message: 'Signature Confirmation Required',
        customerFacingMessage: 'Please Wait',
        icon: 'pencil',
        actions: [
            ActionNames.CONFIRM_SIGNATURE,
            ActionNames.REJECT_SIGNATURE,
            ActionNames.REPRINT_RECEIPT,
        ],
    },
    CONTINUE_REQUIRED: {
        id: 19,
        message: 'Continue Required',
        icon: 'pause',
        actions: [
            ActionNames.CONTINUE_TRANSACTION,
        ],
    },
    CONFIRM_AUTH_CODE: {
        id: 20,
        message: 'Confirm Auth Code',
        icon: 'question-sign',
        actions: [
            ActionNames.CONFIRM_AUTH_CODE,
            ActionNames.REJECT_AUTH_CODE,
        ],
    },
    CONFIRMING_TRANSACTION: {
        id: 21,
        message: 'Confirming Transaction',
        customerFacingMessage: 'Please Wait',
    },
    REJECTING_TRANSACTION: {
        id: 22,
        message: 'Rejecting Transaction',
        customerFacingMessage: 'Declined',
    },
    FINAL_RESULT_RECEIVED: {
        id: 23,
        message: 'Final Result Received',
        customerFacingMessage: 'Please Wait',
    },
    VOICE_REFERRAL: {
        id: 24,
        message: 'Voice Referral',
        customerFacingMessage: 'Referral',
        actions: [
            ActionNames.VOICE_REFERRAL_AUTHORISED,
            ActionNames.VOICE_REFERRAL_REJECTED,
        ],
    },
    REMOVE_CARD: {
        id: 25,
        message: 'Remove Card',
        customerFacingMessage: 'Remove Card',
        icon: 'eject',
    },
    AUTH_RESULT_ERROR: {
        id: 26,
        message: 'Auth Result Error',
    },
    FALLBACK_TO_SWIPE_DISABLED: {
        id: 27,
        message: 'Fallback To Swipe Disabled',
    },
    DOWNLOADING_FILE: {
        id: 28,
        message: 'Downloading File',
        customerFacingMessage: 'Loading',
    },
    UPDATING_PED: {
        id: 29,
        message: 'Updating PED',
        customerFacingMessage: 'Loading',
    },
    INVALID_PED_CONFIGURATION: {
        id: 30,
        message: 'Invalid PED Configuration',
    },
    CARD_DATA_RETRIEVAL: {
        id: 31,
        message: 'Card Data Retrieval',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    STARTING_TRANSACTION: {
        id: 32,
        message: 'Starting Transaction',
        customerFacingMessage: 'Please Wait',
    },
    PERFORMING_DOWNLOAD: {
        id: 33,
        message: 'Performing Download',
        customerFacingMessage: 'Loading',
    },
    REQUESTING_REPORT: {
        id: 34,
        message: 'Requesting Report',
        customerFacingMessage: 'Please Wait',
    },
    GRATUITY_SELECTION_REQUIRED: {
        id: 35,
        message: 'Gratuity Selection Required',
        icon: 'hand-up',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    EXPIRY_DATE_REQUIRED: {
        id: 36,
        message: 'Expiry Date Required',
        customerFacingMessage: 'Expires MM/YY',
        icon: 'hand-up',
        actions: [
            // ActionNames.CANCEL_TRANSACTION, // Docs say you can cancel now but it doesn't work.
        ],
    },
    START_DATE_REQUIRED: {
        id: 37,
        message: 'Start Date Required',
        customerFacingMessage: 'Valid From MM/YY',
        icon: 'hand-up',
        actions: [
            // ActionNames.CANCEL_TRANSACTION, // Docs say you can cancel now but it doesn't work.
        ],
    },
    ISSUE_NUMBER_REQUIRED: {
        id: 38,
        message: 'Issue Number Required',
        customerFacingMessage: 'Issue Number',
        icon: 'hand-up',
        actions: [
            // ActionNames.CANCEL_TRANSACTION, // Docs say you can cancel now but it doesn't work.
        ],
    },
    AVS_HOUSE_NUMBER_REQUIRED: {
        id: 39,
        message: 'AVS House Number Required',
        customerFacingMessage: 'Enter House Number',
        icon: 'hand-up',
        actions: [
            // ActionNames.CANCEL_TRANSACTION, // Docs say you can cancel now but it doesn't work.
        ],
    },
    AVS_POST_CODE_REQUIRED: {
        id: 40,
        message: 'AVS Post Code Required',
        customerFacingMessage: 'Enter Post Code',
        icon: 'hand-up',
        actions: [
            // ActionNames.CANCEL_TRANSACTION, // Docs say you can cancel now but it doesn't work.
        ],
    },
    CSC_REQUIRED: {
        id: 41,
        message: 'CSC Required',
        customerFacingMessage: 'Enter Card Security Code',
        icon: 'hand-up',
        actions: [
            // ActionNames.CANCEL_TRANSACTION, // Docs say you can cancel now but it doesn't work.
        ],
    },
    CUSTOMER_PRESENT_NOT_PRESENT_SELECTION_REQUIRED: {
        id: 42,
        message: 'Customer Present / Not Present Selection Required',
        customerFacingMessage: 'Customer Present? Yes/No',
        icon: 'hand-up',
    },
    CUSTOMER_NOT_PRESENT_OPTION_SELECTION_REQUIRED: {
        id: 43,
        message: 'Customer / Not Present Option Selection Required',
        customerFacingMessage: 'hand-up',
    },
    ENTER_CHARGE_AUTH_CODE: {
        id: 44,
        message: 'Enter Charge Auth Code',
        customerFacingMessage: 'Enter Charge Auth Code',
        icon: 'hand-up',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    LOGIN_REQUIRED: {
        id: 45,
        message: 'Login Required',
        icon: 'warning-sign',
    },
    READY: {
        id: 46,
        message: 'Ready',
        customerFacingMessage: 'Ready',
        icon: 'ok-circle',
    },
    CARD_NOT_ACCEPTED: {
        id: 47,
        message: 'Card Not Accepted',
        customerFacingMessage: 'Not Accepted',
    },
    CARD_BLOCKED: {
        id: 48,
        message: 'Card Blocked',
    },
    TRANSACTION_CANCELLED: {
        id: 49,
        message: 'Transaction Cancelled',
        customerFacingMessage: 'Transaction Void',
    },
    INVALID_EXPIRY: {
        id: 50,
        message: 'Invalid Expiry',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    GRATUITY_INVALID: {
        id: 51,
        message: 'Gratuity Invalid',
    },
    INVALID_CARD: {
        id: 52,
        message: 'Invalid Card',
    },
    PRINTING_CUSTOMER_RECEIPT: {
        id: 53,
        message: 'Printing Customer Receipt',
        customerFacingMessage: 'Please Wait',
        icon: 'print',
    },
    INITIALISING_PED: {
        id: 54,
        message: 'Initialising PED',
        customerFacingMessage: 'Please Wait',
    },
    PED_UNAVAILABLE: {
        id: 55,
        message: 'PED Unavailable',
        icon: 'warning-sign',
    },
    CARD_APPLICATION_SELECTION: {
        id: 56,
        message: 'Card Application Selection',
        customerFacingMessage: 'Select Payment Type',
    },
    RETRY_DOWNLOAD: {
        id: 57,
        message: 'Retry Download',
        actions: [
            ActionNames.RETRY_DOWNLOAD,
            ActionNames.CANCEL_DOWNLOAD,
        ],
    },
    RESTART_AFTER_SOFTWARE_UPDATE: {
        id: 58,
        message: 'Restart After Software Update',
    },
    REQUESTING_DCC: {
        id: 59,
        message: 'Requesting DCC',
        customerFacingMessage: 'Please Wait',
    },
    DCC_CURRENCY_CHOICE: {
        id: 60,
        message: 'DCC Currency Choice',
        actions: [
            ActionNames.REPRINT_RECEIPT,
            ActionNames.MERCHANT_CURRENCY_REQUIRED,
            ActionNames.CARDHOLDER_CURRENCY_REQUIRED,
        ],
    },
    CARDHOLDER_DCC_CURRENCY_CHOICE: {
        id: 61,
        message: 'Cardholder DCC Currency Choice',
        customerFacingMessage: 'Please select currency',
    },
    UNSAFE_DOWNLOAD: {
        id: 62,
        message: 'Unsafe Download',
        actions: [
            ActionNames.ACCEPT_UNSAFE_DOWNLOAD,
            ActionNames.REJECT_UNSAFE_DOWNLOAD,
        ],
    },
    UNEXPECTED_LOGIN: {
        id: 63,
        message: 'Unexpected Login',
        actions: [
            ActionNames.REPLACE_ACCOUNT,
            ActionNames.CANCEL_REPLACE_ACCOUNT,
        ],
    },
    START_BARCLAYS_BONUS_TRANSACTION: {
        id: 64,
        message: 'Start Barclays Bonus Transaction',
    },
    UPDATE_BARCLAYS_BONUS_TRANSACTION: {
        id: 65,
        message: 'Update Barclays Bonus Transaction',
    },
    CANCEL_BARCLAYS_BONUS_TRANSACTION: {
        id: 66,
        message: 'Cancel Barclays Bonus Transaction',
    },
    CONFIRM_GRATUITY: {
        id: 67,
        message: 'Confirm Gratuity',
    },
    REGISTER_FOR_ACCOUNT_ON_FILE_DECISION: {
        id: 68,
        message: 'Register For Account On File Decision',
        actions: [
            ActionNames.ACCOUNT_ON_FILE_REGISTRATION_REQUIRED,
            ActionNames.ACCOUNT_ON_FILE_REGISTRATION_NOT_REQUIRED,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    AWAITING_TOKEN_ID: {
        id: 69,
        message: 'Awaiting Token ID',
    },
    BARCLAYS_BONUS_DISCOUNT_SUMMARY: {
        id: 70,
        message: 'Barclays Bonus Discount Summary',
    },
    BARCLAYS_BONUS_USE_BONUS: {
        id: 71,
        message: 'Barclays Bonus Use Bonus',
    },
    BARCLAYS_BONUS_ENTER_REDEMPTION: {
        id: 72,
        message: 'Barclays Bonus Enter Redemption',
    },
    BARCLAYS_BONUS_NOT_AVAILABLE: {
        id: 73,
        message: 'Barclays Bonus Not Available',
    },
    DOWNLOAD_COMPLETE: {
        id: 74,
        message: 'Download Complete',
    },
    DOWNLOAD_STILL_BEING_PREPARED: {
        id: 75,
        message: 'Download Still Being Prepared',
        actions: [
            ActionNames.RETRY_DOWNLOAD,
            ActionNames.CANCEL_DOWNLOAD,
        ],
    },
    SERVER_CONNECTION_FAILED: {
        id: 76,
        message: 'Server Connection Failed',
        actions: [
            ActionNames.ATTEMPT_TO_RECONNECT,
            ActionNames.GO_OFFLINE,
        ],
    },
    RESUME_DOWNLOAD: {
        id: 77,
        message: 'Resume Download',
        actions: [
            ActionNames.RETRY_DOWNLOAD,
            ActionNames.CANCEL_DOWNLOAD,
        ],
    },
    PAYPOINT_ACCOUNT_EXTRACTION_FAILED: {
        id: 78,
        message: 'PayPoint Account Extraction Failed',
    },
    PAYPOINT_AMOUNT_OUTSIDE_ALLOWED_RANGE: {
        id: 79,
        message: 'PayPoint Amount Outside Allowed Range',
        customerFacingMessage: 'Invalid Amount',
    },
    PAYPOINT_CARD_EXPIRED: {
        id: 80,
        message: 'PayPoint Card Expired',
        customerFacingMessage: 'Not Accepted',
    },
    PAYPOINT_INITIALISED: {
        id: 81,
        message: 'PayPoint Initialised',
    },
    PAYPOINT_INITIALISATION_FAILED: {
        id: 82,
        message: 'PayPoint Initialisation Failed',
    },
    PAYPOINT_INITIALISING: {
        id: 83,
        message: 'PayPoint Initialising',
        customerFacingMessage: 'Loading',
    },
    PAYPOINT_INVALID_ACCOUNT: {
        id: 84,
        message: 'PayPoint Invalid Account',
    },
    PAYPOINT_INVALID_AMOUNT: {
        id: 85,
        message: 'PayPoint Invalid Amount',
    },
    PAYPOINT_INVALID_CAPTURE_METHOD: {
        id: 86,
        message: 'PayPoint Invalid Capture Method',
    },
    PAYPOINT_INVALID_CARD_NUMBER: {
        id: 87,
        message: 'PayPoint Invalid Card Number',
    },
    PAYPOINT_INVALID_CONFIGURATION: {
        id: 88,
        message: 'PayPoint Invalid Configuration',
    },
    PAYPOINT_INVALID_DENOMINATION: {
        id: 89,
        message: 'PayPoint Invalid Denomination',
    },
    PAYPOINT_INVALID_EXPIRY_DATE: {
        id: 90,
        message: 'PayPoint Invalid Expiry Date',
    },
    PAYPOINT_INVALID_SCHEME: {
        id: 91,
        message: 'PayPoint Invalid Scheme',
    },
    PAYPOINT_INVALID_SCHEME_OPTION: {
        id: 92,
        message: 'PayPoint Invalid Scheme Option',
    },
    PAYPOINT_INVALID_TOPUP_TYPE: {
        id: 93,
        message: 'PayPoint Invalid Top-up Type',
    },
    PAYPOINT_INVALID_SERVICE_PROVIDER: {
        id: 94,
        message: 'PayPoint Invalid Service Provider',
    },
    PAYPOINT_INVALID_TRACK2_FORMAT: {
        id: 95,
        message: 'PayPoint Invalid Track2 Format',
    },
    PAYPOINT_INVALID_TRANSACTION_TYPE: {
        id: 96,
        message: 'PayPoint Invalid Transaction Type',
    },
    PAYPOINT_KEYED_ENTRY_NOT_ALLOWED: {
        id: 97,
        message: 'PayPoint Keyed Entry Not Allowed',
    },
    PAYPOINT_MERCHANT_REFERENCE_REQUIRED: {
        id: 98,
        message: 'PayPoint Merchant Reference Required',
        customerFacingMessage: 'Please Wait',
    },
    PAYPOINT_NO_ACCOUNTS: {
        id: 99,
        message: 'PayPoint No Accounts',
    },
    PAYPOINT_PROCESSING_TRANSACTION: {
        id: 100,
        message: 'PayPoint Processing Transaction',
        customerFacingMessage: 'Please Wait',
    },
    PAYPOINT_RETRY_CONFIRMATION_DECISION: {
        id: 101,
        message: 'PayPoint Retry Confirmation Decision',
        customerFacingMessage: 'Please Wait',
        actions: [
            ActionNames.RETRY_PAYPOINT_CONFIRMATION,
            ActionNames.CANCEL_PAYPOINT_CONFIRMATION,
        ],
    },
    PAYPOINT_SCHEME_NOT_RECOGNISED: {
        id: 102,
        message: 'PayPoint Scheme Not Recognised',
        customerFacingMessage: 'Invalid Scheme',
    },
    PAYPOINT_TRANSACTION_CANCELLED: {
        id: 103,
        message: 'PayPoint Transaction Cancelled',
        customerFacingMessage: 'Transaction Void',
    },
    PAYPOINT_TRANSACTION_TYPE_NOT_ALLOWED: {
        id: 104,
        message: 'PayPoint Transaction Type Not Allowed',
        customerFacingMessage: 'Not Accepted',
    },
    PAYPOINT_SELECT_SCHEME_OPTION: {
        id: 105,
        message: 'PayPoint Select Scheme Option',
        customerFacingMessage: 'Select Scheme',
        actions: [
            ActionNames.SELECT_PAYPOINT_OPTION,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    PAYPOINT_DOWNLOAD_REQUIRED: {
        id: 106,
        message: 'PayPoint Download Required',
    },
    PAYPOINT_SELECT_ACCOUNT: {
        id: 107,
        message: 'PayPoint Select Account',
        actions: [
            ActionNames.SELECT_PAYPOINT_ACCOUNT,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    PRINTING_PAYPOINT_RECEIPT: {
        id: 108,
        message: 'Printing PayPoint Receipt',
        customerFacingMessage: 'Printing Receipt',
    },
    LICENCE_DETAIL_CONFIRMATION: {
        id: 109,
        message: 'Licence Detail Confirmation',
        customerFacingMessage: 'Please Wait',
        actions: [
            ActionNames.ACCEPT_LICENCE_KEY,
            ActionNames.REJECT_LICENCE_KEY,
            ActionNames.CANCEL_LICENCE_KEY_VERIFICATION,
        ],
    },
    LICENCE_FILE_REQUIRED: {
        id: 110,
        message: 'Licence File Required',
        customerFacingMessage: 'Loading',
        actions: [
            ActionNames.CONTINUE_LICENCE_KEY_VERIFICATION,
        ],
    },
    PAY_POINT_SERVICE_UNAVAILABLE: {
        id: 111,
        message: 'Pay Point Service Unavailable',
    },
    PARK_RETAIL_GIFT_ACCOUNT_EXTRACTION_FAILED: {
        id: 112,
        message: 'Park Retail Gift Account Extraction Failed',
    },
    PARK_RETAIL_GIFT_AMOUNT_OUTSIDE_ALLOWED_RANGE: {
        id: 113,
        message: 'Park Retail Gift Amount Outside Allowed Range',
    },
    PARK_RETAIL_GIFT_CARD_EXPIRED: {
        id: 114,
        message: 'Park Retail Gift Card Expired',
    },
    PARK_RETAIL_GIFT_INITIALISATION_FAILED: {
        id: 115,
        message: 'Park Retail Gift Initialisation Failed',
    },
    PARK_RETAIL_GIFT_INITIALISING: {
        id: 116,
        message: 'Park Retail Gift Initialising',
    },
    PARK_RETAIL_GIFT_INVALID_ACCOUNT: {
        id: 117,
        message: 'Park Retail Gift Invalid Account',
    },
    PARK_RETAIL_GIFT_INVALID_AMOUNT: {
        id: 118,
        message: 'Park Retail Gift Invalid Amount',
    },
    PARK_RETAIL_GIFT_INVALID_CAPTURE_METHOD: {
        id: 119,
        message: 'Park Retail Gift Invalid Capture Method',
    },
    PARK_RETAIL_GIFT_INVALID_CARD_NUMBER: {
        id: 120,
        message: 'Park Retail Gift Invalid Card Number',
    },
    PARK_RETAIL_GIFT_INVALID_CONFIGURATION: {
        id: 121,
        message: 'Park Retail Gift Invalid Configuration',
    },
    PARK_RETAIL_GIFT_INVALID_EXPIRY_DATE: {
        id: 122,
        message: 'Park Retail Gift Invalid Expiry Date',
    },
    PARK_RETAIL_GIFT_INVALID_TRACK2_FORMAT: {
        id: 123,
        message: 'Park Retail Gift Invalid Track2 Format',
    },
    PARK_RETAIL_GIFT_INVALID_TRANSACTION_TYPE: {
        id: 124,
        message: 'Park Retail Gift Invalid Transaction Type',
    },
    PARK_RETAIL_GIFT_KEYED_ENTRY_NOT_ALLOWED: {
        id: 125,
        message: 'Park Retail Gift Keyed Entry Not Allowed',
    },
    PARK_RETAIL_GIFT_MERCHANT_REFERENCE_REQUIRED: {
        id: 126,
        message: 'Park Retail Gift Merchant Reference Required',
    },
    PARK_RETAIL_GIFT_NO_ACCOUNTS: {
        id: 127,
        message: 'Park Retail Gift No Accounts',
    },
    PARK_RETAIL_GIFT_SERVICE_UNAVAILABLE: {
        id: 128,
        message: 'Park Retail Gift Service Unavailable',
    },
    PARK_RETAIL_GIFT_PROCESSING_TRANSACTION: {
        id: 129,
        message: 'Park Retail Gift Processing Transaction',
    },
    PARK_RETAIL_GIFT_SCHEME_NOT_RECOGNISED: {
        id: 131,
        message: 'Park Retail Gift Scheme Not Recognised',
    },
    PARK_RETAIL_GIFT_SELECT_ACCOUNT: {
        id: 132,
        message: 'Park Retail Gift Select Account',
    },
    PARK_RETAIL_GIFT_TRANSACTION_CANCELLED: {
        id: 133,
        message: 'Park Retail Gift Transaction Cancelled',
    },
    PARK_RETAIL_GIFT_TRANSACTION_TYPE_NOT_ALLOWED: {
        id: 134,
        message: 'Park Retail Gift Transaction Type Not Allowed',
        actions: [
            ActionNames.CONFIRM_SIGNATURE,
            ActionNames.REJECT_SIGNATURE,
            ActionNames.CONFIRM_PARK_RETAIL_GIFT_TRANSACTION,
            ActionNames.REVERSE_PARK_RETAIL_GIFT_TRANSACTION,
        ],
    },
    PRINTING_PARK_RETAIL_GIFT_RECEIPT: {
        id: 135,
        message: 'Printing Park Retail Gift Receipt',
    },
    PED_IN_ESD_RECOVERY_MODE: {
        id: 136,
        message: 'PED In ESD Recovery Mode',
    },
    UPDATE_TRANSACTION_VALUE_DECISION: {
        id: 137,
        message: 'Update Transaction Value Decision',
        actions: [
            ActionNames.NO_TRANSACTION_VALUE_UPDATE_REQUIRED,
            ActionNames.TRANSACTION_VALUE_UPDATE_REQUIRED,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    UPDATE_BARCLAYCARD_FREEDOM_CONFIG: {
        id: 138,
        message: 'Update Barclaycard Freedom Config',
    },
    PROCESSING_KEY_EXCHANGE: {
        id: 139,
        message: 'Processing Key Exchange',
    },
    BARCLAYS_GIFT_INITIALISING: {
        id: 140,
        message: 'Barclays Gift Initialising',
    },
    GLOBAL_BLUE_TAX_FREE_SHOPPING_INITIALISING: {
        id: 141,
        message: 'Global Blue Tax Free Shopping Initialising',
    },
    GIVEX_INITIALISING: {
        id: 142,
        message: 'GiveX Initialising',
    },
    M_VOUCHER_INITIALISING: {
        id: 143,
        message: 'M-Voucher Initialising',
    },
    PERFORMING_POST_CONFIRM_REVERSAL: {
        id: 144,
        message: 'Performing Post Confirm Reversal',
    },
    INVALID_AMOUNT: {
        id: 145,
        message: 'Invalid Amount',
    },
    MERCHANT_REFERENCE_REQUIRED: {
        id: 146,
        message: 'Merchant Reference Required',
        actions: [
            ActionNames.MERCHANT_REFERENCE_ENTERED,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    MERCHANT_REFERENCE_LENGTH_INVALID: {
        id: 147,
        message: 'Merchant Reference Length Invalid',
    },
    INITIALISING: {
        id: 148,
        message: 'Initialising',
    },
    ACCOUNT_EXTRACTION_FAILED: {
        id: 149,
        message: 'Account Extraction Failed',
    },
    AMOUNT_OUTSIDE_ALLOWED_RANGE: {
        id: 150,
        message: 'Amount Outside Allowed Range',
    },
    ENTER_AMOUNT: {
        id: 151,
        message: 'Enter Amount',
    },
    CONFIRM_AUTHORISATION: {
        id: 152,
        message: 'Confirm Authorisation',
        actions: [
            ActionNames.CONFIRM_SIGNATURE,
            ActionNames.REJECT_SIGNATURE,
            ActionNames.REPRINT_RECEIPT,
            ActionNames.CONFIRM_AUTH_CODE,
            ActionNames.REJECT_AUTH_CODE,
        ],
    },
    CARD_EXPIRED: {
        id: 153,
        message: 'Card Expired',
    },
    TRANSAX_SV_INITIALISATION_FAILED: {
        id: 154,
        message: 'Transax SV Initialisation Failed',
    },
    TRANSAX_SV_INITIALISING: {
        id: 155,
        message: 'Transax SV Initialising',
    },
    INVALID_ACCOUNT: {
        id: 156,
        message: 'Invalid Account',
    },
    INVALID_CAPTURE_METHOD: {
        id: 157,
        message: 'Invalid Capture Method',
    },
    INVALID_CARD_NUMBER: {
        id: 158,
        message: 'Invalid Card Number',
    },
    INVALID_CONFIGURATION: {
        id: 159,
        message: 'Invalid Configuration',
    },
    INVALID_EXPIRY_DATE: {
        id: 160,
        message: 'Invalid Expiry Date',
    },
    INVALID_TRACK2_FORMAT: {
        id: 161,
        message: 'Invalid Track2 Format',
    },
    INVALID_TRANSACTION_TYPE: {
        id: 162,
        message: 'Invalid Transaction Type',
    },
    KEYED_ENTRY_NOT_ALLOWED: {
        id: 163,
        message: 'Keyed Entry Not Allowed',
    },
    NO_ACCOUNTS: {
        id: 164,
        message: 'No Accounts',
    },
    CARD_SCHEME_NOT_RECOGNISED: {
        id: 165,
        message: 'Card Scheme Not Recognised',
    },
    TRANSACTION_TYPE_NOT_ALLOWED: {
        id: 166,
        message: 'Transaction Type Not Allowed',
    },
    TRANSAX_SV_SERVICE_UNAVAILABLE: {
        id: 167,
        message: 'Transax SV Service Unavailable',
    },
    INVALID_ISSUE_NUMBER: {
        id: 168,
        message: 'Invalid Issue Number',
    },
    INVALID_CARD_SECURITY_CODE: {
        id: 169,
        message: 'Invalid Card Security Code',
    },
    CONFIRMATION_FAILED: {
        id: 170,
        message: 'Confirmation Failed',
    },
    PRINTING_RECEIPT: {
        id: 171,
        message: 'Printing Receipt',
        icon: 'print',
    },
    WAITING_FOR_DONATION: {
        id: 172,
        message: 'Waiting For Donation',
        icon: 'pause',
    },
    PIN_BLOCKED: {
        id: 173,
        message: 'PIN Blocked',
        icon: 'warning-sign',
    },
    PIN_TRY_LIMIT_EXCEEDED: {
        id: 174,
        message: 'PIN Try Limit Exceeded',
        icon: 'warning-sign',
    },
    FURTHER_PAYMENT_REQUIRED: {
        id: 175,
        message: 'Further Payment Required',
        actions: [
            ActionNames.FURTHER_PAYMENT_REQUIRED,
            ActionNames.NO_FURTHER_PAYMENT_REQUIRED,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    SVS_INITIALISING: {
        id: 176,
        message: 'SVS Initialising',
    },
    SVS_INITIALISATION_FAILED: {
        id: 177,
        message: 'SVS Initialisation Failed',
    },
    SVS_INVALID_CONFIGURATION: {
        id: 178,
        message: 'SVS Invalid Configuration',
    },
    SVS_SERVICE_UNAVAILABLE: {
        id: 179,
        message: 'SVS Service Unavailable',
    },
    CANNOT_CONTINUE_TRANSACTION: {
        id: 180,
        message: 'Cannot Continue Transaction',
    },
    PART_PAYMENT: {
        id: 181,
        message: 'Part Payment',
        actions: [
            ActionNames.ACCEPT_PART_PAYMENT,
            ActionNames.REJECT_PART_PAYMENT,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    OBTAIN_STAN: {
        id: 182,
        message: 'Obtain STAN',
        actions: [
            ActionNames.SUPPLY_STAN,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    INVALID_STAN: {
        id: 183,
        message: 'Invalid STAN',
    },
    IVR_REQUIRED: {
        id: 184,
        message: 'IVR Required',
        actions: [
            ActionNames.SUPPLY_IVR_DETAILS,
            ActionNames.REJECT_IVR,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    PROMPT_FOR_AUTHORISATION_CODE: {
        id: 185,
        message: 'Prompt For Authorisation Code',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    INVALID_AUTH_CODE: {
        id: 186,
        message: 'Invalid Auth Code',
    },
    OFFLINE_TXN_FAILED: {
        id: 187,
        message: 'Offline Txn Failed',
    },
    ENTER_REFERENCE: {
        id: 188,
        message: 'Enter Reference',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    PRINT_SHOP_COPY: {
        id: 189,
        message: 'Print Shop Copy',
        actions: [
            ActionNames.PRINT_SHOP_COPY_RECEIPT,
            ActionNames.CANCEL_SHOP_COPY_RECEIPT,
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    MUST_INSERT_CARD: {
        id: 190,
        message: 'Must Insert Card',
    },
    PIN_ENTERED: {
        id: 191,
        message: 'PIN Entered',
    },
    CARD_SWIPED: {
        id: 192,
        message: 'Card Swiped',
    },
    PIN_BYPASSED: {
        id: 193,
        message: 'PIN Bypassed',
    },
    CANCELLING_TRANSACTION: {
        id: 194,
        message: 'Cancelling Transaction',
    },
    CARD_PRESENTED: {
        id: 195,
        message: 'Card Presented',
    },
    SERVER_ERROR: {
        id: 196,
        message: 'Server Error',
    },
    ON_HOLD_TRANSACTION: {
        id: 197,
        message: 'On Hold Transaction',
    },
    REACTIVATION_REQUIRED: {
        id: 198,
        message: 'Reactivation Required',
    },
    OPTIONAL_DOWNLOAD_AVAILABLE: {
        id: 204,
        message: 'Optional Download Available',
    },
    CARD_NOT_RECOGNISED: {
        id: 205,
        message: 'Card Not Recognised',
    },
    CARD_SCHEME_DOES_NOT_ALLOW_TRANSACTION: {
        id: 206,
        message: 'Card Scheme Does Not Allow Transaction',
    },
    CHOOSE_ACCOUNT: {
        id: 207,
        message: 'Choose Account',
    },
    CONNECTION_FAILED_DOWNLOAD: {
        id: 208,
        message: 'Connection Failed Download',
    },
    SUBMITTING_OFFLINE_TXNS: {
        id: 209,
        message: 'Submitting Offline Txns',
    },
};

module.exports = Statuses;
